import React from 'react';
import './TitleWithline.scss';

function TitleWithLine(props) {

    return (
        <div className={`title-line ${props.className}`}>
            {props.title !== "" ? <p>{props.title}</p> : ""}
            <div className={props.LineClass}></div>
        </div>
    );
}

export default TitleWithLine;